module.exports = __webpack_public_path__ + "static/media/EE.10148440.svg";